import { normalizeDisplayName } from "../shared/protocol";

export const PLAYER_NAME_STORAGE_KEY = "breakroom-player-name";

export function loadPlayerName(): string {
  try {
    return normalizeDisplayName(localStorage.getItem(PLAYER_NAME_STORAGE_KEY)) ?? "";
  } catch {
    return "";
  }
}

export function savePlayerName(value: string): string {
  const normalized = normalizeDisplayName(value) ?? "";
  try {
    if (normalized) localStorage.setItem(PLAYER_NAME_STORAGE_KEY, normalized);
    else localStorage.removeItem(PLAYER_NAME_STORAGE_KEY);
  } catch {
    // Private mode or quota errors should not block play.
  }
  return normalized;
}
